import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  styled,
  tableCellClasses
} from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Styling similar to SupportChat
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 16, // Increased font size
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15, // Increased font size
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const DocumentsDrawer = ({ documents = [] }) => {
  const { t } = useTranslation();

  // Function to open document in new tab
  const openDocument = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!documents || documents.length === 0) {
    return (
      <Box textAlign="center" p={3}>
        <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>{t("dashboard.documents.no_documents")}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '8px', mb: 2 }}>
      <Typography variant="h6" component="h2" gutterBottom sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
        {t("dashboard.documents.available_documents")}
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align="center">{t("dashboard.documents.sl_no")}</StyledTableCell>
              <StyledTableCell>{t("dashboard.pages.document_name")}</StyledTableCell>
              <StyledTableCell align="center">{t("dashboard.documents.view")}</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {documents.map((doc, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell align="center">{index + 1}</StyledTableCell>
                <StyledTableCell>{doc.document_type || t("dashboard.documents.unknown_document")}</StyledTableCell>
                <StyledTableCell align="center">
                  {doc.document_url ? (
                    <IconButton
                      onClick={() => openDocument(doc.document_url)}
                      size="medium"
                    >
                      <OpenInNew />
                    </IconButton>
                  ) : (
                    <Typography sx={{ fontSize: '0.95rem' }}>{t("dashboard.documents.no_url")}</Typography>
                  )}
                </StyledTableCell>
              </StyledTableRow>
            ))}
            {documents.length === 0 && (
              <StyledTableRow>
                <StyledTableCell colSpan={3} align="center" sx={{ fontSize: '1rem' }}>
                  {t("dashboard.documents.no_documents")}
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DocumentsDrawer;